<template>
  <div class="dialog-upload-thesis big-box" style="background-color:#fff">
    <ul class="tab-bar">
      <div class="tabbarbox" style="height:10px"></div>
      <li @click="activeclass=0" :class="{active:activeclass===0}">① 汇总数据表</li>
      <div class="tabbarbox"></div>
      <li @click="activeclass=1" :class="{active:activeclass===1}">② 论文原文</li>
      <div class="tabbarbox"></div>
      <li @click="activeclass=2" :class="{active:activeclass===2}">③ 论文摘要</li>
      <div class="tabbarbox"></div>
      <li @click="activeclass=3" :class="{active:activeclass===3}">④ 论文简况表</li>
      <div class="tabbarbox"></div>
      <li @click="activeclass=4" :class="{active:activeclass===4}">⑤ 论文自评表</li>
      <div class="tabbarbox" style="height:10px"></div>
    </ul>
    <Form :label-width="140" class="btnnextF" v-show="activeclass===0">
      <FormItem  label="汇总数据上传表" class="summary">
        <element-upload url="/paper/paperBaseInfo/upload"
                        :format="['xlsx']"
                        :data={}
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="boxthree">温馨提示:<br><br>1.文件命名规则：KFPY_学校代码_HZSJB.xlsx,<br>例如: KFPY_10001_HZSJB.xlsx;<br><br>2.<a href="/static/demo/KFPY_10001_HZSJB.xlsx">点此下载汇总数据表模板</a></div>
      <div class="btnnext" @click="Gonext">下一步</div>
    </Form>
    <Form :label-width="140" v-show="activeclass===1" class="btnnextF">
      <FormItem  label="论文原文上传" class="originPaper">
        <uploader ref="uploaderZip"
                  :options="options1"
                  :auto-start="true"
                  :file-status-text="statusText1"
                  :single="true"
                  class="uploaderZip"
                  @file-added="onFileAdded"
                  @file-success="handleSuccess">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop class="twostyle1">
            <uploader-btn :attrs="{accept: 'application/zip,application/x-zip,application/x-zip-compressed'}" class="twostyle2">选择文件</uploader-btn>
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>
      </FormItem>
      <div class="boxtwo">温馨提示:<br><br>压缩包命名规则：KFPY_学校代码_LW<br>文件命名规则：学校代码_二级学科码_学号_LW<br><br>例如：10001_081202_100012013120001_LW</div>
      <div class="btnnext" @click="Gonext">下一步</div>
    </Form>
    <Form :label-width="140" v-show="activeclass===2" class="btnnextF">
      <FormItem  label="论文摘要上传" class="summary" style="margin-left:-19px">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="boxthree">温馨提示:<br><br>压缩包命名规则：KFPY_学校代码_ZY<br>文件命名规则：学校代码_二级学科码_学号_ZY<br><br>例如：10001_081202_100012013120001_ZY</div>
      <div class="btnnext" @click="Gonext">下一步</div>
    </Form>
    <Form :label-width="140" v-show="activeclass===3" class="btnnextF">
      <FormItem  label="论文简况表上传" class="summary">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
      <div class="boxthree">温馨提示:<br><br>压缩包命名规则：KFPY_学校代码_JKB<br>文件命名规则：学校代码_二级学科码_学号_JKB<br><br>例如：10001_081202_100012013120001_JKB</div>
      <div class="btnnext" @click="Gonext">下一步</div>
    </Form>
    <Form :label-width="140" v-show="activeclass===4" class="btnnextF">
      <FormItem  label="论文自评表上传" class="summary">
        <element-upload url="/paper/fileOriginalInfo/uploadFile"
                        :format="['zip']"
                        :data="{}"
                        @on-success="handleSuccess"
        ></element-upload>
      </FormItem>
       <div class="boxthree">温馨提示:<br><br>压缩包命名规则：KFPY_学校代码_ZPB<br>文件命名规则：学校代码_二级学科码_学号_ZPB<br><br>例如：10001_081202_100012013120001_ZPB</div>
      <div class="btnnext" @click="winclose('true')">完成</div>
    </Form>
  </div>
</template>

<script>
import ElementUpload from '@/components/elements/upload'

export default {
  name: 'uploadThesis',
  components: {ElementUpload},
  data () {
    return {
      activeclass: 0,
      statusText1: {
        success: '上传成功',
        error: '上传失败',
        uploading: '上传中',
        paused: '暂停中',
        waiting: '等待中'
      },
      options1: {
        target: '/dup/file/fileUpload',
        chunkSize: 5 * 1024 * 1024,
        testChunks: false,
        query: {},
        headers: {
          token: this.$store.state.user.token
        }
      }
    }
  },
  methods: {
    winclose () {
      this.$emit('reload')
    },
    Gonext () {
      this.activeclass++
    },
    handleSuccess () {
      this.$emit('fetchTableList')
    },
    onFileAdded (file) {
      // 添加时间戳
      this.options1.query.timestamp = new Date().getTime();
      this.post('/paper/fileOriginalInfo/checkFileName/' + file.name).then(res => {
      }).catch(() => {
        file.cancel();
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .dialog-upload-thesis {
    display: flex;
    height: 270px;
    .tabbarbox{
      height: 30px;
      width: 20px;
      margin-left: 5.5px;
      border-left: 1px solid rgba(00,00,00,0.09);
    }
    .twostyle1{
      height: 30px;
      width: 100px;
      position: relative;
    }
    .twostyle2{
      border-style: none;
      position: absolute;
      top: 2px;
    }
    .boxone{
      margin-left: 37px;
    }
    .boxtwo{
      margin-left: 42px;
      margin-top: 57px;
    }
    .boxthree{
      margin-left: 42px;
    }
    .btnnextF{
      position: relative;
      flex: 1;
    }
    .btnnext{
      text-align: center;
      line-height: 30px;
      position: absolute;
      bottom: 1px;
      left: 180px;
      width: 60px;
      height: 30px;
      border-radius: 5px;
      background-color: #3bafda;
      color: #ffffff;
      cursor:pointer;
    }
    .tab-bar{
      list-style: none;
    }
    .tab-bar li{
      cursor:pointer;
      width: 84px;
      font-size: 13px;
      height: 13px;
      line-height: 13px;
      text-align: left;
    }
    .tab-bar li.active{
      width: 84px;
      color: #3bafda;
    }
    .originPaper{
      margin-top: 10px;
      margin-left: -19px;
    }
    /deep/.originPaper,summary{
      .kh-form-item-label::before{
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-size: 12px;
        color: #ff7372;
      }
    }
    /deep/.summary{
      margin-left: -7px;
      margin-top: 10px;
      width: 490px;
      .kh-form-item-label::before{
        content: '*';
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-size: 12px;
        color: #ff7372;
      }
    }
    /deep/.uploader-list {
      position: absolute;
      left: -80px;
      right: 0;
      top: 35px;
      .uploader-file {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/dialogs/thesisManage/uploadThesis.vue